import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import IntlStore from "stories/IntlStore";
import { Text } from "./Text";
import { Input } from "./Input";
import { Step } from "../SignUp/constants";
import { EmailInput } from "./emailInput";

interface LoginPasswordProps {
  step?: Step;
  errors?: {
    email?: React.ReactNode;
    password?: React.ReactNode;
  }
}

export const LoginPassword: React.FC<LoginPasswordProps> = props => {
  return (
    <Container>
      <Text>
        <FormattedMessage id="Auth.SignUp.ByEmail" defaultMessage="or by email" />
      </Text>
      <InputContainer>
        <EmailInput
          name="email"
          placeholder={IntlStore.intl.formatMessage({
            id: "Auth.EmailPlaceholder",
            defaultMessage: "Email"
          })}
          error={props.errors?.email}
        />
        {props.step === Step.Form && (
          <EmailInput
            name="password"
            type="password"
            placeholder={IntlStore.intl.formatMessage({
              id: "Auth.PasswordPlaceholder",
              defaultMessage: "Password"
            })}
            error={props.errors?.password}
          />
        )}
      </InputContainer>
    </Container>
  )
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
